module.exports = __webpack_public_path__ + "static/icons/icon-caret-up-c2f1daf655ba11189c8504b64c311a78.svg";